import { render, staticRenderFns } from "./Elecciones.vue?vue&type=template&id=e08d4104&scoped=true&"
import script from "./Elecciones.vue?vue&type=script&lang=js&"
export * from "./Elecciones.vue?vue&type=script&lang=js&"
import style0 from "./Elecciones.vue?vue&type=style&index=0&id=e08d4104&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08d4104",
  null
  
)

export default component.exports